export const MUTUAL_FUNDS_SCHEMES = "MUTUAL_FUNDS_SCHEMES";
export const MUTUAL_FUNDS_SCHEMES_APPLY_SORT = "MUTUAL_FUNDS_SCHEMES_APPLY_SORT";
export const MUTUAL_FUNDS_SCHEMES_UPDATE_SORTED_DATA = "MUTUAL_FUNDS_SCHEMES_UPDATE_SORTED_DATA";
export const MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA = "MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA";
export const MUTUAL_FUNDS_SCHEMES_UPDATE_MSG = "MUTUAL_FUNDS_SCHEMES_UPDATE_MSG";
export const MUTUAL_FUNDS_SCHEMES_CLEAR_MSG = "MUTUAL_FUNDS_SCHEMES_CLEAR_MSG";
export const MUTUAL_FUNDS_SCHEMES_CLEAR_SORT = "MUTUAL_FUNDS_SCHEMES_CLEAR_SORT";
export const MUTUAL_FUNDS_SCHEMES_ERROR = "MUTUAL_FUNDS_SCHEMES_ERROR";
export const MUTUAL_FUNDS_SCHEMES_HIDE_ERROR = "MUTUAL_FUNDS_SCHEMES_HIDE_ERROR";
export const MUTUAL_FUNDS_SCHEMES_START_LOADER = "MUTUAL_FUNDS_SCHEMES_START_LOADER";
export const MUTUAL_FUNDS_SCHEMES_STOP_LOADER = "MUTUAL_FUNDS_SCHEMES_STOP_LOADER";
export const MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER = "MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER";
export const MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER = "MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER";
export const MUTUAL_FUNDS_SCHEMES_PARAMS = "MUTUAL_FUNDS_SCHEMES_PARAMS";
export const MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA = "MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA";
